import React, { useEffect, useState } from 'react';
import { Alert, Button, Col, Modal, ModalBody, ModalHeader, Row, Spinner } from 'reactstrap';
import TextInput from '../../pages/components/inputs/TextInput';
import { Icon, RSelect } from '../Component';
import { getSelectedOption, messageToast } from '../../utils/Utils';
import { tenant_auth_actions_helper } from '../../actions/actions_helper';
import { fail_retrieve_warehouse_sites, loading_retrieve_warehouse_sites, reset_retrieve_warehouse_sites, success_retrieve_warehouse_sites } from '../../reducers/auth_tenant/retrieve_warehouse_sites_Slice';
import { useDispatch } from 'react-redux';
import { RETIREVE_WAREHOUSE_SITES_ERROR_MSG, RETIREVE_WAREHOUSE_SITES_SUCCESS_MSG, RETRIEVE_SALES_REPRESENTATIVES_ERROR_MSG, RETRIEVE_SALES_REPRESENTATIVES_SUCCESS_MSG, TENANT_BACK_DATE_ORDER_ERROR_MSG, TENANT_BACK_DATE_ORDER_SUCCESS_MSG } from '../../utils/error_success_messages';
import { RETRIEVE_TENANT_SALES_REP_BY_STATUS_API, RETRIEVE_TENANT_WAREHOUSE_SITES_BY_STATUS_API, TENANT_BACK_DATE_ORDER_API } from '../../api/api_data';
import { fail_retrieve_tenant_sales_reps, loading_retrieve_tenant_sales_reps, reset_retrieve_tenant_sales_reps, success_retrieve_tenant_sales_reps } from '../../reducers/auth_tenant/retrieve_tenant_sales_reps_Slice';
import * as app_consts from "../../utils/app_consts";
import { useSelector } from 'react-redux';
import { fail_tenant_back_date_order, loading_tenant_back_date_order, reset_tenant_back_date_order, success_tenant_back_date_order } from '../../reducers/auth_tenant/tenant_back_date_order_Slice';
import { useNavigate } from 'react-router';

const intialState = { order_name: "", sales_rep_id: "", warehouse_site_id: "", back_date_date: "", comments: "", consigner: "sales_rep" };

const BackDateOrderModal = ({ isOpen, toggle, successFunction, tenant_info, user_info }) => {

 const navigate = useNavigate();
 const [error, setError] = useState("");
 const [loading, setLoading] = useState("");
 const [form_data, setFormData] = useState(intialState);
 const [open, setOpen] = useState(isOpen);
 const dispatch = useDispatch();
 const [warehouse_sites, setWarehouseSites] = useState();
 const [sales_rep_data, setSalesRepData] = useState([]);
 const [back_date_loading, setBackDateLoading] = useState(false);
 const [back_date_error, setBackDateError] = useState("");

 useEffect(() => {
  setOpen(isOpen);
  if (isOpen)
  {
   setOpen(isOpen);
   setFormData(intialState);
   retrieve_back_data();
  }
 }, [isOpen]);

 const retrieve_back_data = () => {
  // Retrieve Active Warehouse Site
  dispatch(tenant_auth_actions_helper(loading_retrieve_warehouse_sites, success_retrieve_warehouse_sites, fail_retrieve_warehouse_sites, RETIREVE_WAREHOUSE_SITES_ERROR_MSG, RETIREVE_WAREHOUSE_SITES_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_TENANT_WAREHOUSE_SITES_BY_STATUS_API}/${app_consts.ACTIVE}`));
  // Retrieve Sales Rep
  dispatch(tenant_auth_actions_helper(loading_retrieve_tenant_sales_reps, success_retrieve_tenant_sales_reps, fail_retrieve_tenant_sales_reps, RETRIEVE_SALES_REPRESENTATIVES_ERROR_MSG, RETRIEVE_SALES_REPRESENTATIVES_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_TENANT_SALES_REP_BY_STATUS_API}/${app_consts.ACTIVE}`));
 };

 // Listen
 const retrieve_warehouse_sites_listener = useSelector((state) => state.retrieve_warehouse_sites.retrieve_warehouse_sites);

 useEffect(() => {
  if (retrieve_warehouse_sites_listener.status !== app_consts.IDLE)
  {
   if (retrieve_warehouse_sites_listener.status === app_consts.LOADING)
   {
    console.log("Warehouse Sites Loading");
   } else
   {
    if (retrieve_warehouse_sites_listener.status === app_consts.FAIL)
    {
     messageToast(retrieve_warehouse_sites_listener.message, app_consts.FAIL);
    } else if (retrieve_warehouse_sites_listener.status === app_consts.SUCCESS)
    {
     return_warehouse_sites(retrieve_warehouse_sites_listener.data);
    }
    dispatch(reset_retrieve_warehouse_sites());
   }
  }
 }, [retrieve_warehouse_sites_listener]);

 // Sales Reps
 const retrieve_tenant_sales_reps_listener = useSelector((state) => state.retrieve_tenant_sales_reps.retrieve_tenant_sales_reps);

 useEffect(() => {
  if (retrieve_tenant_sales_reps_listener.status !== app_consts.IDLE)
  {
   if (retrieve_tenant_sales_reps_listener.status === app_consts.LOADING)
   {
    console.log("Sales Reps Loading");
   } else
   {
    if (retrieve_tenant_sales_reps_listener.status === app_consts.FAIL)
    {
     messageToast(retrieve_tenant_sales_reps_listener.message, app_consts.FAIL);
    } else if (retrieve_tenant_sales_reps_listener.status === app_consts.SUCCESS)
    {
     return_sales_reps(retrieve_tenant_sales_reps_listener.data);
    }
    dispatch(reset_retrieve_tenant_sales_reps());
   }
  }
 }, [retrieve_tenant_sales_reps_listener]);

 // Grouping Sales Reps
 const return_sales_reps = (sites) => {
  const sales_reps = sites?.map((item) => {
   return { label: item?.name, value: item?.id };
  });
  setSalesRepData(sales_reps);
 };

 // Grouping Warehouse Sites
 const return_warehouse_sites = (sites) => {
  const ware_sites = sites?.map((item) => {
   return { label: item?.name, value: item?.id };
  });
  setWarehouseSites(ware_sites);
 };

 // Handle Change Function
 const handleChange = (e) => {
  setFormData({ ...form_data, [e.target.name]: e.target.value });
 };

 const yesterday = new Date();
 yesterday.setDate(yesterday.getDate() - 1);
 const maxDate = yesterday.toISOString().slice(0, 16);

 const handle_back_date_submit = () => {
  setBackDateError("");

  // Get the browser's timezone offset in minutes
  const offsetMinutes = new Date().getTimezoneOffset();
  const offsetHours = Math.abs(offsetMinutes) / 60;
  const offsetSign = offsetMinutes > 0 ? "-" : "+";
  const formattedOffset = `${offsetSign}${String(offsetHours).padStart(2, "0")}:00`;

  const back_date_api_data = {
   ...form_data,
   back_date_date: `${form_data?.back_date_date}${formattedOffset}`,
  };

  // Back Date Order
  dispatch(tenant_auth_actions_helper(loading_tenant_back_date_order, success_tenant_back_date_order, fail_tenant_back_date_order, TENANT_BACK_DATE_ORDER_ERROR_MSG, TENANT_BACK_DATE_ORDER_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${TENANT_BACK_DATE_ORDER_API}`, back_date_api_data));
 };
 const tenant_back_date_order_listener = useSelector((state) => state.tenant_back_date_order.tenant_back_date_order);

 useEffect(() => {
  if (tenant_back_date_order_listener.status !== app_consts.IDLE)
  {
   if (tenant_back_date_order_listener.status === app_consts.LOADING)
   {
    setBackDateLoading(true);
    setBackDateError("");
   } else
   {
    setBackDateLoading(false);
    if (tenant_back_date_order_listener.status === app_consts.FAIL)
    {
     setBackDateError(tenant_back_date_order_listener.message);
     messageToast(tenant_back_date_order_listener.message, app_consts.FAIL);
    } else if (tenant_back_date_order_listener.status === app_consts.SUCCESS)
    {
     navigate(`/${tenant_info.url_prefix}/orders/${tenant_back_date_order_listener?.data?.order_ref_number}`);
    }
    dispatch(reset_tenant_back_date_order());
   }
  }
 }, [tenant_back_date_order_listener]);

 return (
  <>
   < Modal isOpen={open} className="modal-dialog-centered" size={"lg"} >
    <ModalHeader toggle={back_date_loading ? "" : toggle}>Back Date Order</ModalHeader>
    <ModalBody>
     <Row className="g-4">
      <TextInput
       label="Order Name/Destination"
       type="text"
       id_val="order_name"
       value={form_data?.order_name}
       colSize="6"
       required
       name="order_name"
       handleChange={handleChange}
      />
      <Col lg={6}>
       <div className="form-group">
        <label className="form-label mb-1 text-md" htmlFor="retrunable">
         Warehouse Site Location<span className='text-danger pr-2'>{` *`}</span>
        </label>
        <div className="w-100">
         <RSelect
          options={warehouse_sites?.map((p) => {
           return (
            {
             label: p?.label,
             value: p?.value
            }
           );
          })}
          className="w-100"
          placeholder="Search"
          value={getSelectedOption(form_data?.warehouse_site_id, warehouse_sites)}
          onChange={(e) => setFormData({ ...form_data, warehouse_site_id: e?.value })}
         />
        </div>
       </div>
      </Col>
      <Col lg={6}>
       <div className="form-group">
        <label className="form-label mb-1 text-md" htmlFor="retrunable">
         Consigner<span className='text-danger pr-2'>{` *`}</span>
        </label>
        <div className="w-100">
         <RSelect
          options={[{ label: "Sales Rep", value: "sales_rep" }, { label: "Employee", value: "employee" }]?.map((p) => {
           return (
            {
             label: p?.label,
             value: p?.value
            }
           );
          })}
          className="w-100"
          placeholder="Search"
          value={getSelectedOption(form_data?.consigner, [{ label: "Sales Rep", value: "sales_rep" }, { label: "Employee", value: "employee" }])}
          onChange={(e) => setFormData({ ...form_data, consigner: e?.value, sales_rep_id: "" })}
         />
        </div>
       </div>
      </Col>
      {
       form_data?.consigner && (
        <>
         {
          form_data?.consigner === "sales_rep" ?
           <>
            <Col lg={6}>
             <div className="form-group">
              <label className="form-label mb-1 text-md" htmlFor="retrunable">
               Sales Rep<span className='text-danger pr-2'>{` *`}</span>
              </label>
              <div className="w-100">
               <RSelect
                options={sales_rep_data?.map((p) => {
                 return (
                  {
                   label: p?.label,
                   value: p?.value
                  }
                 );
                })}
                className="w-100"
                placeholder="Search"
                value={getSelectedOption(form_data?.sales_rep_id, sales_rep_data)}
                onChange={(e) => setFormData({ ...form_data, sales_rep_id: e?.value })}
               />
              </div>
             </div>
            </Col>
           </>
           :
           form_data?.consigner === "employee" ?
            <>
             <TextInput
              label="Employee"
              type="text"
              id_val="employee"
              value={`${user_info?.first_name} ${user_info?.last_name}`}
              colSize="6"
              required
              name="employee"
              disabled
             />
            </>
            :
            null
         }
        </>
       )
      }
      <Col lg={6}>
       <div className="form-group">
        <label className="form-label mb-1 text-md" htmlFor="retrunable">
         Date<span className='text-danger pr-2'>{` *`}</span>
        </label>
        <div className="w-100">

         <input
          type="datetime-local"
          name="pre_auction_start_date"
          value={form_data?.back_date_date}
          className="form-control"
          max={maxDate}
          onChange={(e) => setFormData({ ...form_data, back_date_date: e.target.value })}
         />
        </div>
       </div>
      </Col>

      <Col lg="12">
       <div className="form-group">
        <label className="form-label mb-1 text-md" htmlFor="comments">
         Comment<span className='text-danger pr-2'>{` *`}</span>
        </label>
        <div className="form-control-wrap">
         <textarea
          className="no-resize form-control"
          type="textarea"
          id="default-textarea"
          name='comments'
          onChange={handleChange}
         />
        </div>
       </div>
      </Col>
      {back_date_error && (
       <div className="mb-3 w-100">
        <Alert color="danger" className="alert-icon">
         <Icon name="alert-circle" /> {back_date_error}{" "}
        </Alert>
       </div>
      )}
      <Col xl="12" className="d-flex justify-content-end mt-4 mr-2">
       <Button onClick={handle_back_date_submit} disabled={back_date_loading ||
        form_data?.consigner === "employee" ? !(form_data?.back_date_date && form_data?.comments && form_data?.consigner && form_data?.order_name && form_data?.warehouse_site_id) : !(form_data?.back_date_date && form_data?.comments && form_data?.consigner && form_data?.order_name && form_data?.sales_rep_id && form_data?.warehouse_site_id)
       } color="primary">
        {back_date_loading ? <Spinner size="sm" color="light" /> : "Backdate Order"}
       </Button>
      </Col>
     </Row>
    </ModalBody>
   </Modal>
  </>
 );
};

export default BackDateOrderModal;